export default "__VITE_ASSET__BnX435AU__"